module.exports = __webpack_public_path__ + "static/media/uai_v2.048b68f5.PNG";